import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { axiosPath } from "../../../routing/helpers/router";
import * as moduleAction from "../../../store/actions/moduleAction";

export default function UserManagementBase() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();

  // > LOAD MODULE DATA //
  const loadModuleData = useCallback(async () => {
    dispatch(
      moduleAction.fetch(
        axiosPath("api_r_user_module_userManagement_getModuleData"),
        "moduleData",
        {
          moduleBridgeHex,
        }
      )
    );
  }, []);

  useEffect(() => {
    loadModuleData();
  }, []);
  // > LOAD MODULE DATA //

  // < STORE CALLS
  const loadModulePermissions = useCallback(async () => {
    try {
      await dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_userManagement_getPermissions'),
          'permissions',
          {
            moduleBridgeHex,
            subType: 'permissions',
          },
        ),
      );
      await dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_userManagement_getPermissions'),
          'userBridge',
          {
            moduleBridgeHex,
            subType: 'userBridge',
          },
        ),
      );
    } catch (err) {}
  }, [moduleBridgeHex]);

  useEffect(() => {
    loadModulePermissions();
  }, [moduleBridgeHex]);
  // < STORE CALLS

//   if (moduleData && permissionsLevel !== undefined) {
//     return <Outlet />;
//   }

  return null;
}
